<template>
  <section class="ubicacion-card">
    <div class="header">
      <h2 class="titulo">Cómo llegar con Google</h2>
      <p class="descripcion">
        Visítanos en el Centro Comercial Latin Center, local 01, Planta Baja.
        Explora el mapa interactivo o haz clic en el botón para obtener la ruta.
      </p>
    </div>
    
    <div class="contenido">
      <!-- Columna Izquierda: Imagen del Local (Completa) -->
      <div class="frontal-container">
        <div class="glow-border"></div>
        <img src="../assets/Img/Empresas/local-frontal.png" alt="Frente del local" class="local-frontal"/>
      </div>

      <!-- Columna Derecha: Mapa Interactivo y Botón -->
      <div class="mapa-columna">
        <div class="mapa-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3946.7619448221116!2d-69.2012908!3d9.554742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e7cf9ec4561e91d%3A0x6b33e8a5b3e2b6b9!2sCentro%20Comercial%20Latin%20Center!5e0!3m2!1ses!2sve!4v1715000000000!5m2!1ses!2sve" 
            width="100%" 
            height="100%" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
          <div class="map-overlay"></div>
        </div>
        <a :href="mapsUrl" target="_blank" class="btn">Abrir ruta en Google Maps</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "UbicacionCard",
  data() {
    return {
      mapsUrl: "https://www.google.com/maps/dir/?api=1&destination=Centro+Comercial+Latin+Center,+Acarigua,+Portuguesa",
    };
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;800&display=swap');

/* ===== CONTENEDOR PRINCIPAL ===== */
.ubicacion-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;
  background: #030812;
  max-width: 1200px;
  margin: 2rem auto;
  border-radius: 24px;
  border: 1px solid rgba(0, 229, 255, 0.15);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6);
  font-family: 'Poppins', sans-serif;
  position: relative;
  overflow: hidden;
}

/* Efecto de cuadrícula sutil de fondo */
.ubicacion-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 229, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 229, 255, 0.02) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: radial-gradient(circle at center, #000 20%, transparent 80%);
  -webkit-mask-image: radial-gradient(circle at center, #000 20%, transparent 80%);
  pointer-events: none;
  z-index: 0;
}

/* ===== TEXTOS ===== */
.header {
  position: relative;
  z-index: 10;
  text-align: center;
  margin-bottom: 3rem;
}

.titulo {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.8rem;
  text-shadow: 0 0 25px rgba(0, 229, 255, 0.4);
  letter-spacing: 0.5px;
}

.descripcion {
  font-size: 1.05rem;
  color: #b9c9d9;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ===== CONTENIDO (CUADRÍCULA PERFECTA) ===== */
.contenido {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr 1fr; /* Mitad y mitad exacta */
  gap: 2.5rem;
  width: 100%;
  align-items: stretch; /* Iguala las alturas */
}

/* ===== IMAGEN DEL LOCAL ===== */
.frontal-container {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: #0a121e;
  border: 1px solid rgba(0, 229, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px; /* Para el borde brillante */
}

/* Borde brillante animado */
.glow-border {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  padding: 2px;
  background: linear-gradient(135deg, #00e5ff, transparent 40%, transparent 60%, #1a73e8);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  opacity: 0.5;
  transition: opacity 0.4s ease;
}

.frontal-container:hover .glow-border {
  opacity: 1;
}

/* La imagen completa, sin recortes */
.local-frontal {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Usamos cover pero el contenedor tiene la misma altura que el mapa */
  border-radius: 12px;
  transition: transform 0.6s ease, filter 0.6s ease;
  filter: brightness(0.95);
}

.frontal-container:hover .local-frontal {
  transform: scale(1.05);
  filter: brightness(1.1);
}

/* ===== MAPA INTERACTIVO ===== */
.mapa-columna {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.mapa-container {
  width: 100%;
  height: 100%; /* Ocupa todo el alto disponible */
  min-height: 350px; /* Altura mínima para que se vea bien */
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(0, 229, 255, 0.3);
  box-shadow: 0 0 30px rgba(0, 229, 255, 0.1);
  background: #0a121e;
  transition: box-shadow 0.4s ease;
}

.mapa-container:hover {
  box-shadow: 0 0 40px rgba(0, 229, 255, 0.3);
}

.mapa-container iframe {
  width: 100%;
  height: 100%;
  border: none;
  filter: invert(90%) hue-rotate(180deg) contrast(1.2);
  transition: filter 0.4s ease;
}

.mapa-container:hover iframe {
  filter: invert(0%) hue-rotate(0deg) contrast(1);
}

/* Efecto de borde animado en el mapa */
.map-overlay {
  position: absolute;
  inset: 0;
  box-shadow: inset 0 0 20px rgba(0, 229, 255, 0.2);
  pointer-events: none;
  border-radius: 16px;
  transition: box-shadow 0.3s ease;
}

.mapa-container:hover .map-overlay {
  box-shadow: inset 0 0 0 rgba(0, 229, 255, 0);
}

/* ===== BOTÓN ===== */
.btn {
  display: block;
  background: linear-gradient(135deg, #00e5ff, #1a73e8);
  color: #04121a;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(0, 229, 255, 0.3);
  text-align: center;
  width: 100%;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 0 35px rgba(0, 229, 255, 0.6);
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px) {
  .contenido {
    grid-template-columns: 1fr; /* Una columna en tablets y celulares */
    gap: 2rem;
  }

  .mapa-container {
    min-height: 300px;
  }
  
  .titulo {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .ubicacion-card {
    padding: 3rem 1rem;
    border-radius: 0;
    border: none;
  }
  
  .titulo { font-size: 1.8rem; }
  .descripcion { font-size: 0.95rem; }
}
</style>